module.exports = __webpack_public_path__ + "static/media/app-screenshot.19c474d0.png";